/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  ListUserNotificationsParams,
  UserNotificationListResponse,
  UserNotificationUpdateRequest,
  UserNotificationUpdateResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useListUserNotificationsHook = () => {
        const listUserNotifications = useCustomInstance<UserNotificationListResponse>();

        return useCallback((
    params?: ListUserNotificationsParams,
 signal?: AbortSignal
) => {
        return listUserNotifications(
          {url: `/UserNotification/List`, method: 'GET',
        params, signal
    },
          );
        }, [listUserNotifications])
      }
    

export const getListUserNotificationsQueryKey = (params?: ListUserNotificationsParams,) => {
    return [`/UserNotification/List`, ...(params ? [params]: [])] as const;
    }

    
export const useListUserNotificationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError = unknown>(params?: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserNotificationsQueryKey(params);

  const listUserNotifications =  useListUserNotificationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>> = ({ signal }) => listUserNotifications(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserNotificationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>>
export type ListUserNotificationsQueryError = unknown


export function useListUserNotifications<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError = unknown>(
 params: undefined |  ListUserNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserNotifications<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError = unknown>(
 params?: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserNotifications<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError = unknown>(
 params?: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUserNotifications<TData = Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError = unknown>(
 params?: ListUserNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserNotificationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListUserNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useUpdateUserNotificationHook = () => {
        const updateUserNotification = useCustomInstance<UserNotificationUpdateResponse>();

        return useCallback((
    userNotificationUpdateRequest: UserNotificationUpdateRequest,
 ) => {
        return updateUserNotification(
          {url: `/UserNotification/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userNotificationUpdateRequest
    },
          );
        }, [updateUserNotification])
      }
    


export const useUpdateUserNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationHook>>>, TError,{data: UserNotificationUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationHook>>>, TError,{data: UserNotificationUpdateRequest}, TContext> => {

const mutationKey = ['updateUserNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateUserNotification =  useUpdateUserNotificationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationHook>>>, {data: UserNotificationUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateUserNotification(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserNotificationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationHook>>>>
    export type UpdateUserNotificationMutationBody = UserNotificationUpdateRequest
    export type UpdateUserNotificationMutationError = unknown

    export const useUpdateUserNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationHook>>>, TError,{data: UserNotificationUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserNotificationHook>>>,
        TError,
        {data: UserNotificationUpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateUserNotificationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    